import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchGalleryCategories, createGalleryCategory, fetchGalleryCategory, modifyGalleryCategory, deleteGalleryCategoryApi, getAllCategoriesApi, changeStatus } from '../../api/gallerryCategoryApi';

export const getGalleryCategories = createAsyncThunk('category/getCategories', async ({payload}, { rejectWithValue }) => {
  try {
    const response = await fetchGalleryCategories(payload);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const addGalleryCategory = createAsyncThunk('category/addCategory', async (payload, { rejectWithValue }) => {
  try {
    const response = await createGalleryCategory(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getGalleryCategoryDetails = createAsyncThunk('category/getCategoryDetails', async (categoryId, { rejectWithValue }) => {
  try {
    const response = await fetchGalleryCategory(categoryId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const updateGalleryCategory = createAsyncThunk('category/updateCategory', async (payload, { rejectWithValue }) => {
  try {
    const response = await modifyGalleryCategory(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const deleteGalleryCategory = createAsyncThunk('category/deleteCategory', async (categoryId, { rejectWithValue }) => {
  try {
    const response = await deleteGalleryCategoryApi(categoryId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getAllCategories = createAsyncThunk('category/getAllCategories', async (payload) => {
  try {
    const response = await getAllCategoriesApi(payload);
    return response.data;
  } catch (error) {
    return "error";
  }
});

export const changeActiveStatus = createAsyncThunk('category/changeDefaultStatus', async (categoryId, { rejectWithValue }) => {
  try {
    const response = await changeStatus(categoryId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});


const galleryCategorySlice = createSlice({
  name: 'galleryCategory',
  initialState: {
    categories: [],
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGalleryCategories.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getGalleryCategories.fulfilled, (state, action) => {
        state.isLoading = false;
        state.categories = action.payload;
      })
      .addCase(getGalleryCategories.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export default galleryCategorySlice.reducer;
